(function () {
  'use strict';

  var config = window.worldMapConfig;
  if (!config || !document.getElementById('destinations')) {
    return;
  }

  var countryData = [];
  var homepage = config.shopUrl || window.location.origin;

  function normalizeName(name) {
    return name
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[.'']/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function findCountry(name) {
    var normalized = normalizeName(name);
    var match = null;
    var i;

    for (i = 0; i < countryData.length; i++) {
      if (normalizeName(countryData[i].Country) === normalized) {
        return countryData[i];
      }
    }

    for (i = 0; i < countryData.length; i++) {
      var countryName = normalizeName(countryData[i].Country);
      if (countryName.indexOf(normalized) !== -1 || normalized.indexOf(countryName) !== -1) {
        return countryData[i];
      }
    }

    return match;
  }

  function clearMapHighlights() {
    document.querySelectorAll('#world-map-svg path').forEach(function (el) {
      el.classList.remove('active');
      Array.prototype.slice.call(el.classList).forEach(function (cls) {
        if (cls.indexOf('--active') !== -1 || cls.indexOf('country-highlight-') === 0) {
          el.classList.remove(cls);
        }
      });
    });
  }

  function clearHighlights() {
    document.querySelectorAll('[data-type]').forEach(function (el) {
      el.className = 'flex-1 text-center-0 faded-40 type-handler';
    });

    clearMapHighlights();

    document.getElementById('toCollections').innerHTML = '';
  }

  function appendCollectionLink(typeCode) {
    var typeLower = typeCode.toLowerCase();
    var container = document.getElementById('toCollections');
    var link = document.createElement('a');
    link.className = 'btn btn--complementary btn--lg marg-top marg-bottom marg-left marg-right';
    link.href = homepage + '/collections/type-' + typeLower;
    link.textContent = 'Show type-' + typeLower + ' adapters';
    container.appendChild(link);
  }

  function highlightCountryOnMap(countryName, plugTypeStr) {
    var countryPath = document.querySelector('#world-map-svg [data-name="' + countryName + '"]');

    if (!countryPath) {
      document.querySelectorAll('#world-map-svg [data-name]').forEach(function (path) {
        var pathName = path.getAttribute('data-name');
        var normalizedCountry = normalizeName(countryName);
        var normalizedPath = normalizeName(pathName);

        if (
          normalizedPath === normalizedCountry ||
          normalizedPath.indexOf(normalizedCountry) !== -1 ||
          normalizedCountry.indexOf(normalizedPath) !== -1
        ) {
          countryPath = path;
        }
      });
    }

    if (countryPath) {
      countryPath.classList.add('active');

      if (plugTypeStr) {
        var primaryType = plugTypeStr.split('/')[0].toLowerCase();
        countryPath.classList.add('country-highlight-' + primaryType);
      }
    }
  }

  function highlightPlugTypeIcons(plugTypeStr) {
    if (!plugTypeStr) {
      return;
    }

    plugTypeStr.split('/').forEach(function (type) {
      var typeLower = type.toLowerCase();
      var handler = document.querySelector('[data-type="type-' + typeLower + '"]');

      if (handler) {
        handler.classList.remove('faded-40');
        handler.classList.add('border-bottom', 'border-bottom-md', 'border--type-' + typeLower);
      }

      appendCollectionLink(typeLower);
    });
  }

  function highlightCountrySelection(plugTypeStr, countryName) {
    clearHighlights();

    if (!plugTypeStr) {
      return;
    }

    highlightPlugTypeIcons(plugTypeStr);

    if (countryName) {
      highlightCountryOnMap(countryName, plugTypeStr);
    }
  }

  function highlightPlugTypeOnMap(type) {
    clearHighlights();

    var handler = document.querySelector('[data-type="' + type + '"]');

    if (handler) {
      handler.classList.remove('faded-40');
      handler.classList.add('border-bottom', 'border-bottom-md', 'border--' + type);
    }

    document.querySelectorAll('.country-' + type).forEach(function (el) {
      el.classList.add('country-' + type + '--active');
    });

    var container = document.getElementById('toCollections');
    var link = document.createElement('a');
    link.className = 'btn btn--complementary btn--lg marg-top marg-bottom marg-left marg-right';
    link.href = homepage + '/collections/' + type;
    link.textContent = 'Show ' + type + ' adapters';
    container.appendChild(link);
  }

  function syncCustomSelectLabel(select) {
    var customButton = document.querySelector('.mg-custom-select__button');
    if (customButton && select.selectedIndex >= 0) {
      customButton.textContent = select.options[select.selectedIndex].text;
    }
  }

  function setSelectedCountry(select, countryName) {
    var i;

    for (i = 0; i < select.options.length; i++) {
      if (select.options[i].text === countryName) {
        select.selectedIndex = i;
        syncCustomSelectLabel(select);
        return true;
      }
    }

    return false;
  }

  function buildCustomSelect(parent, select) {
    var withSearch = parent.classList.contains('mg-custom-select--search-js');
    var customSelect = document.createElement('div');
    customSelect.classList.add('mg-custom-select');

    var customSelectInvoker = document.createElement('button');
    customSelectInvoker.type = 'button';
    customSelectInvoker.textContent = select.options[select.selectedIndex].text;
    customSelectInvoker.classList.add('mg-custom-select__button');
    customSelect.appendChild(customSelectInvoker);

    var dropdown = document.createElement('div');
    dropdown.classList.add('mg-custom-select__dropdown');

    var searchInput = null;

    if (withSearch) {
      searchInput = document.createElement('input');
      searchInput.classList.add('mg-custom-select__search');
      searchInput.type = 'text';
      searchInput.placeholder = 'Start typing here...';

      var searchInputLabel = document.createElement('label');
      searchInputLabel.classList.add('mg-custom-select__search__label');
      searchInputLabel.textContent = 'Search term: ';
      searchInputLabel.appendChild(searchInput);
      dropdown.appendChild(searchInputLabel);
    }

    var customSelectList = document.createElement('ul');
    customSelectList.classList.add('mg-custom-select__list');
    var selectOptions = select.querySelectorAll('option');
    var customSelectItems = [];

    for (var x = 0; x < selectOptions.length; x++) {
      if (x !== 0) {
        var customSelectItem = document.createElement('li');
        customSelectItem.classList.add('mg-custom-select__list__item');
        customSelectItem.dataset.value = selectOptions[x].value;
        customSelectItem.dataset.index = x;
        customSelectItem.textContent = selectOptions[x].text;
        customSelectList.appendChild(customSelectItem);
        customSelectItems.push(customSelectItem);
      }
    }

    dropdown.appendChild(customSelectList);
    customSelect.appendChild(dropdown);
    parent.appendChild(customSelect);
    select.style.display = 'none';

    customSelectItems.forEach(function (item) {
      item.addEventListener('click', function () {
        dropdown.classList.remove('opened');
        select.value = this.dataset.value;

        Array.prototype.forEach.call(select.options, function (option) {
          option.removeAttribute('selected');
        });

        select.options[this.dataset.index].setAttribute('selected', 'selected');
        select.dispatchEvent(new Event('change', { bubbles: true }));
        customSelectInvoker.textContent = this.textContent;

        if (searchInput) {
          searchInput.value = '';
          customSelectItems.forEach(function (listItem) {
            listItem.classList.remove('hidden');
          });
        }
      });
    });

    if (searchInput) {
      searchInput.addEventListener('keyup', function () {
        var inputVal = this.value;
        var pattern = new RegExp(inputVal, 'i');

        customSelectItems.forEach(function (listItem) {
          if (!listItem.textContent.match(pattern)) {
            listItem.classList.add('hidden');
          } else {
            listItem.classList.remove('hidden');
          }
        });
      });
    }

    customSelectInvoker.addEventListener('click', function () {
      dropdown.classList.toggle('opened');
    });

    document.addEventListener('click', function (event) {
      if (!parent.contains(event.target)) {
        dropdown.classList.remove('opened');
      }
    });
  }

  function bindTypeHandlers() {
    document.querySelectorAll('.type-handler').forEach(function (handler) {
      handler.addEventListener('click', function () {
        highlightPlugTypeOnMap(this.getAttribute('data-type'));
      });
    });
  }

  function bindMapCountries() {
    document.querySelectorAll('#world-map-svg [data-name]').forEach(function (path) {
      path.style.cursor = 'pointer';

      path.addEventListener('click', function () {
        var mapName = this.getAttribute('data-name');
        var country = findCountry(mapName);

        if (!country) {
          return;
        }

        var select = document.getElementById('destinations');
        setSelectedCountry(select, country.Country);
        highlightCountrySelection(country.PlugType, mapName);
      });
    });
  }

  function init() {
    fetch(config.countryDataUrl)
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Failed to load country data');
        }
        return response.json();
      })
      .then(function (data) {
        countryData = data.slice().sort(function (a, b) {
          return a.Country.localeCompare(b.Country);
        });

        var select = document.getElementById('destinations');

        countryData.forEach(function (item) {
          var option = document.createElement('option');
          option.value = item.PlugType;
          option.textContent = item.Country;
          select.appendChild(option);
        });

        document.querySelectorAll('.mg-custom-select-js').forEach(function (parent) {
          buildCustomSelect(parent, select);
        });

        select.addEventListener('change', function () {
          var country = this.options[this.selectedIndex].text;
          var plugType = this.value;

          if (!plugType) {
            clearHighlights();
            return;
          }

          highlightCountrySelection(plugType, country);
        });

        bindTypeHandlers();
        bindMapCountries();
      })
      .catch(function (error) {
        console.error('World map failed to initialize:', error);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
